
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Modal } from 'reactstrap';

const { SearchBar } = Search;

const pagination = paginationFactory({
    sizePerPage: 10,
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
        <div className="dataTables_length" id="datatable-basic_length">
            <label>
                Show{" "}
                {<select
                    name="datatable-basic_length"
                    aria-controls="datatable-basic"
                    className="form-control form-control-sm"
                    onChange={e => onSizePerPageChange(e.target.value)}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>}{" "}
                entries.
            </label>
        </div>
    )
});

class AdminDashboard extends React.Component {

    renderTable = () => (

        <ToolkitProvider
            data={this.props.data}
            keyField="_id"
            columns={this.props.columns}
            search
        >
        {props => (
            <div className="py-4 table-responsive table-vertical-align">
                <div id="datatable-basic_filter" className="dataTables_filter pb-1 w-100" >
                    <label>
                        <SearchBar className="form-control-sm ml-0" placeholder="" {...props.searchProps}/>
                    </label>
                </div>
                <BootstrapTable 
                    {...props.baseProps} 
                    className="xxx" 
                    bootstrap4={true} 
                    pagination={pagination} 
                    bordered={false}
                />
            </div>
        )}
        </ToolkitProvider>

    );
  
    render() {

        if(this.props.modal) {
            return ( 
                <Modal className="modal-dialog-centered" size="lg" style={{maxWidth: '90vw'}} isOpen={this.props.modalShow} toggle={this.props.modalToggle} >
                    <div style={{maxHeight: '90vh', overflow: 'auto'}}>
                        <div className="modal-header pb-0">
                            <h2>{this.props.title}</h2>
                            <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={this.props.modalToggle} >
                                <span aria-hidden={true}>×</span>
                            </button>
                        </div>
                        <div className="modal-body pt-0">
                        { this.renderTable()}
                        </div>
                    </div>
                </Modal>
            )
    
        } else {
            return this.renderTable()
        }

       
    }
}

export default AdminDashboard